<template>
  <div>
    <div class="sixteentosix omt-6 omt-md-25 sixteentosix-wrap">
      <div class="new-background-wrap">
        <div
          class="kachelimage header-image zoom-image"
          style="
            background: url('/static/img/laptop_lock_1.jpg');
            background-position: top !important;
          "
        ></div>
        <!-- <img src="/static/img/video-main-banner.svg" /> -->
        <div class="headline-wrap">
          <div class="headline">
            <div class="text-subtitle-2 text-md-h5">
              {{ $t("target_revenue") }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <Breadcrumb v-if="!editMode" />
    <Breadcrumb v-else :trainingNameEdit="targetRevenueMonthString" />
    <div class="pt-8">
      <div class="mx-0 row disablerow align-items-start">
        <!-- Left Area -->
        <div class="col-xl-9 innercreatetraining px-md-12 px-8 pr-sm-16">
          <div class="mx-0 pa-0 text-content">
            <div class="row pt-0">
              <div class="col-md-12 pt-0">
                <span class="headlinecolor text-h6">
                  {{ $t("target_revenue") }}</span
                >
              </div>
              <div class="col-sm-12 col-md-6">
                <v-select
                  hide-details="auto"
                  :items="sortedCountries"
                  class="datainput justify-content-end align-self-center pb-1"
                  dense
                  outlined
                  :label="$t('country') + '*'"
                  v-model="targetRevenue.country"
                ></v-select>
              </div>
              <div class="col-sm-12 col-md-6">
                <v-select
                  hide-details="auto"
                  :items="years"
                  class="datainput justify-content-end align-self-center pb-1"
                  dense
                  outlined
                  :label="$t('year') + '*'"
                  v-model="targetRevenue.year"
                ></v-select>
              </div>
              <div class="col-sm-12 col-md-6">
                <v-select
                  hide-details="auto"
                  :items="months"
                  item-text="name"
                  item-value="id"
                  class="datainput justify-content-end align-self-center pb-1"
                  dense
                  outlined
                  :label="$t('month') + '*'"
                  v-model="targetRevenue.month"
                ></v-select>
              </div>
              <div class="col-sm-12 col-md-6">
                <v-text-field
                  hide-details="auto"
                  class="datainput justify-content-end align-self-center pb-1"
                  dense
                  outlined
                  :label="$t('targetvalue') + '*'"
                  v-model="targetValueInput"
                  @blur="validateTargetValue"
                ></v-text-field>
              </div>
            </div>

            <div class="col-md-12 lastBtnSubmit mr-0 ml-0">
              <v-btn
                v-if="!editMode"
                v-show="$rights.includes('CREATE_TARGET_REVENUE')"
                @click="savetargetRevenue()"
                outlined
                depressed
                tile
                class="savebutton mr-2 mb-2"
                >{{ $t("save") }}</v-btn
              >
              <v-btn
                v-else
                v-show="$rights.includes('UPDATE_TARGET_REVENUE')"
                @click="savetargetRevenue()"
                outlined
                depressed
                tile
                class="savebutton mr-2 mb-2"
                >{{ $t("save") }}</v-btn
              >
              <v-btn
                @click="$routerBack()"
                outlined
                depressed
                tile
                class="cancelBtn mr-2 mb-2"
                >{{ $t("cancel") }}</v-btn
              >
              <v-btn
                v-show="editMode && $rights.includes('DELETE_TARGET_REVENUE')"
                @click="openDeleteDialog = true"
                outlined
                depressed
                tile
                class="deletebutton trainer-productivity-del-btn cancelBtn mr-2 mb-2"
              >
                <v-icon color="#444">mdi-delete</v-icon>
                {{ $t("delete") }}</v-btn
              >
            </div>
            <div class="text-right">
              <v-label> * {{ $t("mandatory_fields") }} </v-label>
            </div>
          </div>
        </div>

        <!-- Right Area -->
        <div class="col-xl-3 px-0 pl-md-12 row pt-0 onlyContact">
          <div class="col-xl-12 right-side-block hide">
            <h4 class="text-uppercase">{{ $t("actions") }}</h4>
            <div class="right-side divider"></div>
            <div class="mt-6"></div>
          </div>
          <Contact />
        </div>

        <div class="text-center">
          <v-dialog v-model="openDeleteDialog" width="500">
            <div class="Delete-popup-trainer-productivity">
              <h4>{{ $t("delete_trainer_productivity") }}</h4>
              <p>{{ $t("Are_you_sure") }}</p>
              <div class="trainer-productivity-buttons-wrap">
                <v-spacer></v-spacer>
                <v-btn
                  @click="openDeleteDialog = false"
                  outlined
                  depressed
                  tile
                  class="cancelBtn mr-2 mb-2"
                >
                  {{ $t("cancel") }}</v-btn
                >
                <v-btn
                  @click="deletetargetRevenue()"
                  outlined
                  depressed
                  tile
                  class="savebutton mr-2 mb-2"
                >
                  <img
                    src="/static/img/popup-delete-icon.svg"
                    class="popup-delete-icon"
                  />
                  {{ $t("delete") }}</v-btn
                >
              </div>
            </div>
          </v-dialog>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from "./Breadcrumbs.vue";

export default {
  components: {
    Breadcrumb,
  },
  props: {
    trainer_target_revenue_id: Number,
  },

  data() {
    return {
      editMode: false,
      targetValueInput: "",
      targetRevenue: {
        id: null,
        year: new Date().getFullYear(),
        month: new Date().getMonth(),
        country: null,
        targetvalue: null,
      },
      rooms: [],
      years: [2024, 2025, 2026, 2026, 2027, 2028, 2029, 2030],
      openDeleteDialog: false,
      targetRevenueMonthString: "",
      countries: [],
    };
  },

  mounted() {
    this.fetchCountries();
    if (this.trainer_target_revenue_id != null) {
      this.gettargetRevenueData();
      this.editMode = true;
    }
  },

  computed: {
    sortedCountries() {
      return this.countries
        .map((country) => ({
          text: this.$t(country),
          value: country,
        }))
        .sort((a, b) => (a.text > b.text ? 1 : b.text > a.text ? -1 : 0));
    },
    months() {
      return [
        { id: 0, name: this.$t("january") },
        { id: 1, name: this.$t("february") },
        { id: 2, name: this.$t("march") },
        { id: 3, name: this.$t("april") },
        { id: 4, name: this.$t("may") },
        { id: 5, name: this.$t("june") },
        { id: 6, name: this.$t("july") },
        { id: 7, name: this.$t("august") },
        { id: 8, name: this.$t("september") },
        { id: 9, name: this.$t("october") },
        { id: 10, name: this.$t("november") },
        { id: 11, name: this.$t("december") },
      ];
    },
  },

  methods: {
    convertToNumber(input) {
      if (!input) return null;
      return parseFloat(input.replace(/\./g, "").replace(",", "."));
    },
    validateTargetValue() {
      this.targetValueInput = this.validateAndFormatAmount(
        this.targetValueInput
      );
      this.targetRevenue.targetvalue = this.convertToNumber(
        this.targetValueInput
      );
    },
    validateAndFormatAmount(input) {
      if (!input) return "";

      // Fix US-style formats if detected
      input = input.toString();
      input = this.correctInputFormat(input);

      // If already German-style, just append ,00 if needed
      const germanFormatRegex = /^\d{1,3}(\.\d{3})*(,\d{1,2})?$/;
      if (germanFormatRegex.test(input)) {
        return input.includes(",") ? input : `${input},00`;
      }

      // Standard number formatting
      let number = parseFloat(input.replace(/\./g, "").replace(",", "."));
      if (isNaN(number)) return input;

      return new Intl.NumberFormat("de-DE", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(number);
    },
    correctInputFormat(input) {
      // If input is US-style (digits with a dot before 2 decimals), convert it
      const usStyleRegex = /^\d+(\.\d{1,2})?$/;
      if (usStyleRegex.test(input)) {
        return input.replace(/\./, ",");
      }

      // If input is US-style with thousand separators (e.g. 1,234.98)
      const usThousandStyleRegex = /^\d{1,3}(,\d{3})*(\.\d{1,2})?$/;
      if (usThousandStyleRegex.test(input)) {
        return input.replace(/,/g, "").replace(/\./, ",");
      }

      return input; // Return as-is if no match
    },
    fetchCountries() {
      this.$axios
        .get("/api/location/countries")
        .then((response) => {
          this.countries = response.data;
        })
        .catch(this.onError);
    },
    onError(err) {
      if (err.response != null && err.response.data != null) {
        this.$noty.error(err.response.data);
      } else {
        console.error(err);
      }
    },

    lowerCaseMapKeys(map) {
      for (var key in map) {
        if (map.hasOwnProperty(key)) {
          if (key == key.toUpperCase()) continue;
          map[key.toUpperCase()] = map[key];
          delete map[key];
        }
      }
    },

    savetargetRevenue() {
      var _this = this;
      var targetRevenue = {};
      targetRevenue = Object.assign(targetRevenue, this.targetRevenue);
      if (targetRevenue.country == null) {
        this.$noty.error(this.$t("empty_value", { name: this.$t("country") }));
        return;
      }

      if (targetRevenue.year == null) {
        this.$noty.error(this.$t("empty_value", { name: this.$t("year") }));
        return;
      }

      if (targetRevenue.month == null) {
        this.$noty.error(this.$t("empty_value", { name: this.$t("month") }));
        return;
      }

      if (targetRevenue.targetvalue == null) {
        this.$noty.error(
          this.$t("empty_value", { name: this.$t("targetvalue") })
        );
        return;
      }

      if (this.editMode) {
        this.$axios
          .put(
            "/api/target-revenue/update/" + this.trainer_target_revenue_id,
            targetRevenue
          )
          .then(function (response) {
            _this.$noty.success(_this.$t("target_revenue_edited"));
            _this.$router.push("/list-target-revenue");
          })
          .catch(this.onError);
      } else {
        // Create new Training
        this.$axios
          .post("/api/target-revenue/create", targetRevenue)
          .then(function (response) {
            _this.$noty.success(_this.$t("target_revenue_create"));
            _this.$router.push("/list-target-revenue");
          })
          .catch(this.onError);
      }
    },

    deletetargetRevenue() {
      if (this.trainer_target_revenue_id == null) {
        console.error("You are not editing an existing tenant.");
        return;
      }

      var _this = this;

      this.$axios
        .delete("/api/target-revenue/" + this.trainer_target_revenue_id)
        .then(function (response) {
          _this.$noty.success(_this.$t("target_revenue_deleted"));
          _this.$router.push("/list-target-revenue");
        })
        .catch(this.onError);
    },

    gettargetRevenueData() {
      var _this = this;
      this.$axios
        .get(
          "/api/target-revenue/get-target-revenue/" +
            this.trainer_target_revenue_id
        )
        .then(function (response) {
          let targetRevenue = _this.targetRevenue;
          targetRevenue.targetvalue = response.data.targetvalue;
          _this.targetValueInput = response.data.targetvalue;
          _this.validateTargetValue();
          targetRevenue.year = response.data.year;
          targetRevenue.month = response.data.month;
          targetRevenue.country = response.data.country;
          _this.targetRevenueMonthString =
            targetRevenue.year + " " + _this.months[response.data.month].name;
        })
        .catch(this.onError);
    },

    onFinally() {
      showLoadingCircle(false);
    },

    fetchRooms() {
      var _this = this;
      this.$axios
        .get("/api/performanceboard/room-data")
        .then(function (response) {
          //this.rooms = response.data;

          for (var i = 0; i < response.data.length; i++) {
            _this.rooms.push({
              id: response.data[i]["id"],
              name: response.data[i]["designation"],
            });
          }
        })
        .catch(this.onError);
    },
  },
};
</script>
